import React from "react";
import PageTemplate from "./PageTemplate";
import { LineAddButton, HeroSection, Tagline, LINE_BOT_URL } from "./LineShared";

const LineEn = () => {
  return (
    <PageTemplate>

      <HeroSection>
        <h1>BabbleOn + LINE</h1>
        <Tagline>
          Chat with anyone on LINE — in any language. No new apps, no copy-pasting. 
          Just add BabbleOn on LINE and start talking.
        </Tagline>
        <LineAddButton
          href={LINE_BOT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/line-icon.png" alt="LINE" />
          Add BabbleOn on LINE
        </LineAddButton>
      </HeroSection>

      <h2>💬 How It Works</h2>
      <p>
        Add BabbleOn as a friend on LINE. Tap <strong style={{display: 'inline', fontSize: 'inherit', marginTop: 0, marginBottom: 0}}>Start a Babble</strong>, pick the 
        language your friend speaks, and share the invite link. That's it — you 
        both stay in LINE, chatting in your own language, and BabbleOn translates 
        every message in real time.
      </p>

      <h2>🇯🇵 Built for the LINE Community</h2>
      <p>
        LINE is where conversations happen across Japan and SE Asia. BabbleOn 
        plugs directly into those conversations — expats chatting with neighbors, 
        international couples talking with family, travelers navigating a new city. 
        If you use LINE, BabbleOn just works.
      </p>

      <h2>🔄 Real-Time Translation in Your DMs</h2>
      <p>
        Every message is translated instantly by AI and delivered straight to your 
        LINE DMs — with the sender's name and profile picture so it feels like a 
        natural conversation. Your friend sees your message in their language, you 
        see theirs in yours.
      </p>

      <h2>⚡ No App Required</h2>
      <p>
        Nobody needs to download anything or create an account. Share an invite 
        link or QR code, your chat partner scans or taps it, and they're in. The 
        entire experience happens inside LINE.
      </p>

      <h2 style={{textAlign: 'center', marginTop: '2.5rem'}}>Ready to Try It?</h2>
      <p style={{textAlign: 'center'}}>
        Add BabbleOn on LINE and start a translated conversation in seconds.
      </p>
      <div style={{textAlign: 'center', marginTop: '0.5rem'}}>
        <LineAddButton
          href={LINE_BOT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/line-icon.png" alt="LINE" />
          Add BabbleOn on LINE
        </LineAddButton>
      </div>

    </PageTemplate>
  );
};

export default LineEn;
